import { ImageLibraryManager } from '../../components-v2/ImageLibraryManager';

export function ImagesTabPage() {
	return (
		<ImageLibraryManager
			description='Images in this library can be accessed by you and your teammates and can be used anywhere you add images in Levitate. Removing an image takes it out of this library only: content already using it keeps working.'
			emptyDescription={
				'Check "Save to my images" when you add a photo to a newsletter, social post, email, or blog and it will show up here.'
			}
			emptyTitle='Your library is empty'
			heading='My Images'
		/>
	);
}
